import { useContext } from 'react';

import {
  TableContext,
  type TiclickTableContextType,
} from './ticlick-table-context';

export function useTiclickTableContext<T>() {
  const context = useContext<TiclickTableContextType<T> | null>(TableContext);
  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context;
}
